var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg096Twitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1828_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9186 5.9275C19.732 5.35 20.4161 4.62917 20.9736 3.79917V3.79833C20.2295 4.12417 19.4378 4.34083 18.6111 4.44583C19.4611 3.93833 20.1103 3.14083 20.4153 2.18C19.6228 2.6525 18.7478 2.98583 17.8153 3.1725C17.0628 2.37083 15.9903 1.875 14.8203 1.875C12.5503 1.875 10.7228 3.7175 10.7228 5.97583C10.7228 6.30083 10.7503 6.61333 10.8178 6.91083C7.40947 6.74417 4.3928 5.11083 2.36613 2.62167C2.0128 3.23583 1.80447 3.93833 1.80447 4.69417C1.80447 6.11417 2.5353 7.3725 3.62613 8.10167C2.96697 8.08917 2.32113 7.8975 1.77363 7.59667V7.64167C1.77363 9.63417 3.19447 11.2892 5.05863 11.6708C4.72447 11.7625 4.36113 11.8058 3.98363 11.8058C3.72113 11.8058 3.45613 11.7908 3.2078 11.7358C3.73863 13.3592 5.24697 14.5533 7.03863 14.5925C5.64363 15.6833 3.87197 16.3408 1.95447 16.3408C1.61863 16.3408 1.29613 16.3258 0.973633 16.285C2.7903 17.4558 4.94197 18.125 7.26363 18.125C14.4995 18.125 19.2153 12.0883 18.9186 5.9275Z",
    fill: "#3734A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1828_10086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.973633)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg096Twitter);
export default __webpack_public_path__ + "static/media/096-twitter.c29e5b70fec6b57a51ff17eef1d80441.svg";
export { ForwardRef as ReactComponent };